<template>
    <div class="split-content" v-bind:class="{'no-text': !text}">
      <span>
        {{ text }}
      </span>
    </div>
</template>

<script>
    export default {
        name: "SplitContent",
        props: ['text']
    }
</script>

<style scoped>
    .split-content {
        display: block;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        font-size: 1.15em;
        font-weight: 500;
    }

    .split-content > span {
        position: relative;
        display: inline-block;
        font-weight: bold;
    }

    .split-content > span:before,
    .split-content > span:after {
        content: "";
        position: absolute;
        top: 50%;
        width: 9999px;
        height: 1px;
        background: #979797;
    }

    .split-content > span:before {
        right: 100%;
        margin-right: 15px;
    }

    .split-content > span:after {
        left: 100%;
        margin-left: 15px;
    }

    .split-content.no-text > span:before {
        margin-right: 0px;
    }

    .split-content.no-text > span:after {
        margin-left: 0px;
    }
</style>
